import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import HotRanking from './components/HotRanking';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOMeta
        title="韩国漫画大全_最新热门韩国漫画推荐_无删减韩国漫画排行榜"
        description="韩漫漫画网汇集韩国漫画大全，推荐最新热门韩国漫画，提供无删减韩国漫画排行榜，帮助您快速找到优质漫画，享受免费阅读乐趣。每日更新热门韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型。"
        keywords="韩国漫画大全,最新热门韩国漫画推荐,无删减韩国漫画排行榜,韩漫漫画网,韩国漫画,韩漫推荐,webtoon"
        canonicalUrl="https://www.hanmancomic.com/"
      />
      <SchemaOrg
        pageType="WebPage"
        breadcrumbs={[{ name: '首页', url: '/' }]}
        faqData={[
          { question: '韩漫漫画网是什么？', answer: '韩漫漫画网是一个专注于韩国漫画推荐的中文平台。我们精心筛选和评测各类韩国漫画，涵盖多种类型，提供最新热门韩国漫画推荐和真实可靠的排行榜。' },
          { question: '网站上的漫画都是免费的吗？', answer: '韩漫漫画网是推荐和评测平台，提供详细的漫画介绍、评测和分类导航。读者可通过链接前往正版漫画平台阅读。' },
          { question: '如何找到自己喜欢的韩国漫画？', answer: '使用顶部的分类导航按类型浏览，查看首页热门排行榜了解最受欢迎的作品，浏览精选推荐区域发现高质量漫画。' },
          { question: '网站多久更新一次内容？', answer: '韩漫漫画网每日更新，编辑团队持续关注韩国漫画界最新动态，及时更新推荐、排行榜和评测内容。' },
          { question: '如何联系我们？', answer: '发送邮件至 contact@hanmancomic.com，或访问关于我们页面获取更多联系方式。' },
        ]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedComics />
        <HotRanking />
        <CategorySection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}